module.exports = __webpack_public_path__ + "img/rapporto_intervento.f8c1ae87.jpg";